var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonPrimary',_vm._g({staticClass:"relative justify-center",class:{
    'base-spinner cursor-not-allowed': _vm.loading,
  },attrs:{"type":"button","disabled":_vm.loading || _vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }